
import React from 'react';
import { Award, Sparkles } from 'lucide-react';
import { VIPConfig } from '../types';

interface Props {
  config: VIPConfig | null;
  size?: 'sm' | 'md' | 'lg';
}

const VIPBadge: React.FC<Props> = ({ config, size = 'md' }) => {
  if (!config) return null;

  const styles = {
    sm: 'px-2 py-0.5 text-[8px] gap-1 rounded-lg',
    md: 'px-3 py-1 text-[10px] gap-1.5 rounded-xl',
    lg: 'px-6 py-3 text-xs gap-2 rounded-2xl'
  };

  return (
    <div 
      className={`inline-flex items-center font-black uppercase tracking-widest text-white shadow-lg ${styles[size]} relative overflow-hidden group`}
      style={{ backgroundColor: config.color }}
    >
       <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
       <Award className={size === 'lg' ? 'h-4 w-4' : 'h-3 w-3'} />
       {config.label}
       {size === 'lg' && <Sparkles className="h-3 w-3 animate-pulse" />}
    </div>
  );
};

export default VIPBadge;
